﻿import React, { useState, useEffect } from 'react';
import { AssetData } from '../models/asset-data';
import { CrudFunctions } from '../utilities/crud-functions';
import { HplcInstrumentLookupData } from '../models/hplc-instrument-lookup-data';
import { HplcAsset } from '../models/hplc-asset';
import { DataTemplates } from '../templates/data-templates';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';

import {
    SelectBox,
    NumberBox,
    List,
    CheckBox
} from 'devextreme-react';

export interface Props {
    isReadOnly: boolean;
    assetId?: string;
    assetData?: AssetData;
    onHplcInstrumentChanged?: (instrument: HplcAsset) => void;
}

export default function HplcAssetComponent(props: Props) {
    const [hplcAsset, setHplcAsset] =
        useState<HplcAsset>();

    const [hplcInstrumentLookupData, setHplcInstrumentLookupData] =
        useState<HplcInstrumentLookupData>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, [props.assetId]);

    useEffect(() => {
        if (props.onHplcInstrumentChanged)
            props.onHplcInstrumentChanged(hplcAsset);
    }, [hplcAsset]);

    return (
        <div>
            <div className="pw-comp-row">
                <div className="pw-form-unit pw-comp-10">
                    <div className="pw-form-unit-label">Detector</div>
                    <List id="lstDetectors" disabled={props.isReadOnly}
                        className="listbox"
                        items={hplcInstrumentLookupData &&
                            hplcInstrumentLookupData.detectorTypes ?
                            hplcInstrumentLookupData.detectorTypes : []}
                        keyExpr="id"
                        itemRender={DataTemplates.EhsTemplate}
                        showSelectionControls={true}
                        selectionMode="multiple"
                        selectedItems={hplcAsset && hplcAsset.detectors ?
                            hplcAsset.detectors : []}
                        onOptionChanged={selectedDetectorItemsChanged} />
                </div>

                <div className="pw-form-unit pw-comp-15">
                    <div className="pw-form-unit-label">Pump</div>
                    <SelectBox id="pumpType"
                        placeholder="na" readOnly={props.isReadOnly}
                        itemRender={DataTemplates.LocationTemplate}
                        dataSource={hplcInstrumentLookupData &&
                            hplcInstrumentLookupData.pumpTypes ?
                            hplcInstrumentLookupData.pumpTypes : []}
                        onValueChanged={onHplcAssetPumpTypeChanged}
                        valueExpr={'id'} displayExpr="name"
                        value={hplcAsset &&
                            hplcAsset.pumpType ?
                            hplcAsset.pumpType.id : undefined} />
                </div>

                <div className="pw-form-unit pw-comp-15">
                    <div className="pw-form-unit-label">Pump Max Pressure</div>
                    <NumberBox id="pumpMaxPressure" className="textbox"
                        onValueChanged={onHplcValueChanged} readOnly={props.isReadOnly}
                        showClearButton={true}
                        placeholder="na"
                        value={hplcAsset ?
                            hplcAsset.pumpMaxPressure : undefined} />

                    <div className="pw-form-unit pw-comp-15 pw-margin-top-1">
                        <CheckBox id="cooledAutoSampler" readOnly={props.isReadOnly}
                            text="Cooled Auto Sampler"
                            onValueChanged={onHplcValueChanged}
                            value={hplcAsset ? hplcAsset.cooledAutoSampler : false} />
                    </div>
                </div>
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }
        </div>
    );

    function selectedDetectorItemsChanged(e: any) {
        //console.log("selectedDetectorItemsChanged+++");

        if (e.value === e.previousValue)
            return;

        if (hplcAsset && e.name === 'selectedItems') {
            console.log(e);
            setHplcAsset({ ...hplcAsset, detectors: e.value });
        }
    }

    function onHplcValueChanged(e: any) {
        if (e.element && e.element.id) {
            const caller = e.element.id;

            setHplcAsset({ ...hplcAsset, [caller]: e.value });
        }
    }

    function onHplcAssetPumpTypeChanged(e: any) {
        console.log("onHplcAssetPumpTypeChanged");
        console.log(e);

        if (e.value && e.event && hplcInstrumentLookupData &&
            hplcInstrumentLookupData.pumpTypes) {

            const matchingDetector =
                hplcInstrumentLookupData.pumpTypes.find(p => p.id === e.value);

            console.log("matchingDetector:::");
            console.log(matchingDetector);

            if (matchingDetector) {
                //const data = { value: e.value, pump: matchingDetector };
                //if (hplcAsset && e.pump && e.value) {
                if (hplcAsset) {

                    /*
                    let fieldUpdate: FieldUpdate = {
                        entity: "HplcAssets", field: "pumpType",
                        value: e.value, rowId: hplcAsset.assetId
                    };
                    */

                    setHplcAsset({ ...hplcAsset, pumpType: matchingDetector });

                    /* TODO:
                    this.setState((prevState: any) => ({
                        hplcAsset: {
                            ...prevState.hplcAsset,
                            "pumpType": e.pump
                        }
                    }), () => {
                        this.updateAssetField(fieldUpdate)
                            .then(() => {
                                //need to requery the cached set of HPLC assets
                                this.getHplcAssets();
                            });
                    });
                    */

                }
            }
        }
    }

    /*
    function onDetectorItemsChanged(e: any) {
        if (e.value && this.state.selectedAsset && this.state.selectedAsset.assetId) {
            const assetId = this.state.selectedAsset.assetId;
            const detectors = e.value as LookupItem[];

            if (detectors) {
                this.setState((prevState: any) => ({
                    hplcAsset: {
                        ...prevState.hplcAsset,
                        "detectors": detectors
                    }
                }), () => {
                    this.updateHplcAssetDetectors(assetId, detectors)
                        .then(() => {
                            //need to requery the cached set of HPLC assets
                            this.getHplcAssets()
                        });
                });
            }
        }
    }
    */

    async function getHplcInstrumentEnumerations() {
        await CrudFunctions.getData("benchsheets/hplcinstrumentlookupdata")
            .then((data) => {
                setHplcInstrumentLookupData(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving HPLC Enumerations");
            });
    }

    async function getHplcAsset() {
        try {
            const resp = await CrudFunctions.getData(`benchsheets/hplcinstrument/${props.assetId}`);
            setHplcAsset(resp);

        } catch (err) {
            // Database did not find a gc record
            // need to initialize a default so user can update the fields
            setHplcAsset({
                assetId: props.assetId,
                cooledAutoSampler: false
            })
        }
    }

    async function getAllData() {
        if (!props.assetId)
            return;

        await Promise.all([
            getHplcInstrumentEnumerations(),
            getHplcAsset()
        ]);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}
